<ng-container *ngIf="project$ | async as project">
  <!-- Header -->
  <ion-header class="ion-no-border">
    <ion-toolbar mode="ios">
      <ion-buttons slot="end">
        <ion-button (click)="onDismiss(growAccount, project, projectFinishStatus)">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <!-- Content -->
  <ion-content [scrollY]="true">
    <app-ds-header-stepper
      [title]="
        'GROW.project.investmentFlow.step' + activeHeaderStep + (projectFinishStatus === 'reached' ? 'LimitReached' : '') + '.title' | translate
      "
      [currentStep]="activeHeaderStep"
      [finalType]="projectFinishStatus === 'reached' ? 'warning' : 'success'"
      [totalSteps]="3"
    ></app-ds-header-stepper>

    <app-inyova-grow-project-preview [project]="project"></app-inyova-grow-project-preview>
    <div class="inyova-grow-figures" *ngIf="currentStep === investmentSteps.SETUP">
      <!-- Maturity -->
      <app-ds-info-row
        [title]="'GROW.project.figure.duration' | translate"
        [value]="('GROW.project.until' | translate | titlecase) + ' ' + (project.end_date | dateTranslate: 'shortDate' : language)"
        [info]="'GROW.project.figureInfo.duration' | translate"
        customStyle="border-top: none;"
      ></app-ds-info-row>
      <!-- Min. Funding -->
      <app-ds-info-row
        [title]="'GROW.project.figure.minInvestmentAmount' | translate"
        [value]="project.minimum_funding | thousand: project.currency"
        [info]="'GROW.project.figureInfo.minInvestmentAmount' | translate"
      ></app-ds-info-row>
      <!-- Currency -->
      <app-ds-info-row
        [title]="'GROW.project.figure.currency' | translate"
        [value]="project.currency"
        [info]="'GROW.project.figureInfo.currency' | translate"
      ></app-ds-info-row>
    </div>
    <ng-container *ngIf="isEligibleForInvesting(growAccount, project) || currentStep === investmentSteps.DONE; else sufficientFundWarning">
      <div class="grow-investment-steps" [ngSwitch]="currentStep">
        <ng-container *ngSwitchCase="investmentSteps.SETUP">
          <app-inyova-grow-investment-setup
            [project]="project"
            [language]="language"
            [growAccount]="growAccount"
            (submitAmount)="onSubmitAmount($event)"
          ></app-inyova-grow-investment-setup>
        </ng-container>

        <ng-container *ngSwitchCase="investmentSteps.CONFIRM">
          <app-inyova-grow-investment-consent
            [loading]="loading"
            [project]="project"
            [selectedAmount]="selectedAmount"
            [selectedType]="selectedType"
            (submitInvestment)="onSubmitInvestment($event)"
          ></app-inyova-grow-investment-consent>
        </ng-container>

        <ng-container *ngSwitchCase="investmentSteps.DONE">
          <div class="investment-done">
            <ng-container *ngIf="projectFinishStatus === 'success'; else reachedWarning">
              <h2 class="ds-heading-2">{{ 'GROW.project.investmentFlow.step3.nextStepsLabel' | translate }}</h2>
              <ul class="ds-list">
                <!-- TODO 23.05.2024: reenable when email implementation is done -->
                <!-- <li>
                    <app-ds-rounded-icon
                      icon="square-check-big"
                      variant="custom"
                      customColor="var(--color-core-brand-5-3)"
                    ></app-ds-rounded-icon>
                    <div>
                      <p class="ds-heading-3">{{'GROW.project.investmentFlow.step3.step1.label' | translate}}</p>
                      <p class="ds-ui-2 ds-color-core-neutral-8">{{'GROW.project.investmentFlow.step3.step1.description' | translate}}</p>
                    </div>
                  </li> -->
                <li>
                  <app-ds-rounded-icon icon="square-arrow-down" variant="custom" customColor="var(--color-core-brand-4-3)"></app-ds-rounded-icon>
                  <div>
                    <p class="ds-heading-3">{{ 'GROW.project.investmentFlow.step3.step2.label' | translate }}</p>
                    <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.project.investmentFlow.step3.step2.description' | translate }}</p>
                  </div>
                </li>
                <li>
                  <app-ds-rounded-icon icon="earth" variant="custom" customColor="var(--color-core-brand-3-5)"></app-ds-rounded-icon>
                  <div>
                    <p class="ds-heading-3">{{ 'GROW.project.investmentFlow.step3.step3.label' | translate }}</p>
                    <p class="ds-ui-2 ds-color-core-neutral-8">
                      {{
                        'GROW.project.investmentFlow.step3.step3.description'
                          | translate
                            : {
                                interestRate: project.expected_return | percent: '1.1',
                                projectMaturity: project.end_date | dateTranslate: 'shortDate' : language,
                                payout: ('GROW.project.investmentFlow.step3.step3.' + project.payout | translate)
                              }
                      }}
                    </p>
                  </div>
                </li>
              </ul>
            </ng-container>

            <ng-template #reachedWarning>
              <app-ds-callout
                variant="warning"
                [title]="
                  'GROW.project.investmentFlow.' +
                    (project.stage === inyovaGrowProjectStage.CLOSED ? 'step3LimitReached' : 'step3LimitExceeded') +
                    '.callout.heading' | translate
                "
                [description]="
                  'GROW.project.investmentFlow.' +
                    (project.stage === inyovaGrowProjectStage.CLOSED ? 'step3LimitReached' : 'step3LimitExceeded') +
                    '.callout.contents' | translate: { amount: project.account_specific.maximum_additional_amount | thousand: project.currency }
                "
              ></app-ds-callout>
            </ng-template>

            <app-ds-button (clicked)="onDismiss(growAccount, project, projectFinishStatus)">
              {{
                'GROW.project.investmentFlow.' + (projectFinishStatus === 'success' ? 'step3.buttonLabel' : 'step3LimitReached.closeButton')
                  | translate
              }}
            </app-ds-button>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #sufficientFundWarning>
      <app-ds-callout
        variant="warning"
        [title]="
          'GROW.project.investmentFlow.step1.' + (growAccount.stock_split === 0 ? 'riskProfileCallout' : 'callout.insufficientFunds') + '.title'
            | translate
        "
        [description]="
          'GROW.project.investmentFlow.step1.' + (growAccount.stock_split === 0 ? 'riskProfileCallout' : 'callout.insufficientFunds') + '.body'
            | translate
              : {
                  topUpAmount:
                    (project.account_specific.top_up_amount > 0 && project.account_specific.top_up_amount < 1
                      ? 1
                      : project.account_specific.top_up_amount
                    ) | thousand: growAccount.currency,
                  riskProfile: 'GROW.performance.strategy.portfolio.riskProfile.' + riskLevel | translate
                }
        "
      >
        <ng-container actions *ngIf="growAccount.stock_split !== 0">
          <app-ds-link icon="arrow-right" data-cy="button-modal" (click)="onDepositFund()">
            {{ 'GROW.project.investmentFlow.step1.callout.insufficientFunds.action' | translate }}
          </app-ds-link>
        </ng-container>
      </app-ds-callout>

      <app-ds-button type="button" [disabled]="true">{{ 'GROW.project.investmentFlow.step1.buttonLabel' | translate }}</app-ds-button>
    </ng-template>
  </ion-content>
</ng-container>
